export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_service-website-hub/artifacts/1mkaqjn8_Just%20the%20logo%20no%20writing.png";

export const HERO_BG =
  "https://images.unsplash.com/photo-1771793232195-9b00a25b8b3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMG5ldXJhbCUyMG5ldHdvcmslMjBkYXJrJTIwZ3JlZW58ZW58MHx8fHwxNzc3MzIwMzQzfDA&ixlib=rb-4.1.0&q=85";

export const ACCENT_GLOW =
  "https://images.unsplash.com/photo-1763386599810-e31937993312?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGRhcmslMjB0ZWFsJTIwZ3JlZW4lMjBncmFkaWVudCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc3MzIwMzQzfDA&ixlib=rb-4.1.0&q=85";

export const CONTACT = {
  email: "walshconor10@yahoo.ie",
  phone: "085 8828 656",
  phoneRaw: "+353858828656",
  region: "Ireland",
};

// Real homepage captures taken with Playwright (public/projects/).
export const PORTFOLIO = [
  {
    slug: "mccarthy-motors",
    name: "McCarthy Motors Midleton",
    label: "Mechanic Website",
    href: "https://mccarthymotorsmidleton.com/",
    screenshot: "/projects/mccarthy-motors.jpg",
  },
  {
    slug: "cmac-autos",
    name: "C-Mac & Son Autos",
    label: "Auto Garage Website",
    href: "https://cmacandsonautos.ie/",
    screenshot: "/projects/cmac-autos.jpg",
  },
  {
    slug: "ali-dorgan",
    name: "Ali Dorgan",
    label: "Therapy Practice Website",
    href: "https://alidorgan.com/",
    screenshot: "/projects/ali-dorgan.jpg",
  },
  {
    slug: "conor-walsh-coaching",
    name: "Conor Walsh Coaching",
    label: "Coaching Website",
    href: "https://conorwalshcoach.com/",
    screenshot: "/projects/conor-walsh-coaching.jpg",
  },
  {
    slug: "cleanme",
    name: "CleanMe",
    label: "Cleaning Service Website",
    href: "https://cleanme.ie/",
    screenshot: "/projects/cleanme.jpg",
  },
  {
    slug: "onbrand-emails",
    name: "OnBrand Emails",
    label: "Email Marketing Platform",
    href: "https://onbrandemails.com/",
    screenshot: "/projects/onbrand-emails.jpg",
  },
];

export const BUSINESS_TYPES = [
  "Mechanic / Garage",
  "Plumber / Tradesman",
  "Electrician",
  "Salon / Beauty",
  "Coaching",
  "Other Service Business",
];
